import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadPanel, Popup } from "devextreme-react";
import axios from "axios";
import { Toster } from "../../components/Toster/Toster";
import { DynamicTabb } from "../../components/DynamicTab/DynamicTab";
import { Table2 } from "../../components/Table2/Table2";
import AdminCrumbs from "./components/AdminCrumbs";
import AddEditConditionVerbiage from "./AddEditConditionVerbiage";
import { handleGetLocal } from "../../services/auth-service";

const ConditionVerbiage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorHandling, setErrorHandling] = useState(false);
  const [exportPopupOpen, setExportPopupOpen] = useState(false);
  const [data, setData] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMode, setPopupMode] = useState("ADD");
  const [selectedRow, setSelectedRow] = useState(null);
  const pathname = handleGetLocal("pathURL");
  console.log("selectedRow",selectedRow)

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  const Tablecoloum = [
    { title: "", moreoption: true, customwidth: "50px" },
    { title: "Court Name", customwidth: "200px" },
    { title: "Sort", customwidth: "80px" },
    { title: "Condition #", customwidth: "120px" },
    { title: "Condition", customwidth: "350px" },
    { title: "Violation", customwidth: "350px" },
    { title: "First Person", customwidth: "350px" },
    { title: "Third Person", customwidth: "350px" },
  ];

  const setTableData = (apiData) => {
    console.log("apiData", apiData);
    const arr = [];
    apiData?.forEach((val) => {
      arr.push({
        ID: val?.gVerbiageId,
        "Court Name": val?.sCourtName,
        Sort: val?.iSort,
        "Condition #": val?.sConditionNumber,
        Condition: val?.sCondition,
        Violation: val?.sViolation,
        "First Person": val?.sFirstPersonViolation,
        "Third Person": val?.sThirdPersonViolation,
        obj: val,
      });
    });
    setData(arr);
  };
  const getConditionVerbiage = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/document-wizard/conditions-violations`,
        {
          personID: null,
          filter: null,
          selectedDockets: null,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: pathname,
          },
        }
      );
      console.log("tabledata", response?.data?.documentWizardVerbiages);
      setTableData(response?.data?.documentWizardVerbiages || []);
    } catch (err) {
      setErrorHandling(true);
      setToastConfig({
        isVisible: true,
        type: "error",
        message: "Failed to load Condition Verbiage data",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getConditionVerbiage();
  }, []);

  return (
    <>
     <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
     <LoadPanel shadingColor="true" visible={loading} delay={10} /> 
      <Popup
        visible={popupOpen}
        onHiding={() => setPopupOpen(false)}
        showTitle={false}
        width={900}
        height="auto"
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <AddEditConditionVerbiage
          mode={popupMode}
          rowData={selectedRow}
          setPopupOpen={setPopupOpen}
          refresh={getConditionVerbiage}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
        />
      </Popup>
      <AdminCrumbs title={"Condition Verbiage"} user={"Data"} />

      <div className="fee-schedule-container">
        <DynamicTabb />

        <div className="fee-schedule-content">
          <p className="page-info-number">MB.2</p>

          <div className="fee-schedule-buttons">
            <div className="buttons">
              <button className="btn" onClick={() => setExportPopupOpen(true)}>
                Export
                <svg
                  className="svg-blue-dark"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="17"
                  viewBox="0 0 14 17"
                  fill="none"
                >
                  <path
                    d="M11.59 6H10V1C10 0.45 9.55 0 9 0H5C4.45 0 4 0.45 4 1V6H2.41C1.52 6 1.07 7.08 1.7 7.71L6.29 12.3C6.68 12.69 7.31 12.69 7.7 12.3L12.29 7.71C12.92 7.08 12.48 6 11.59 6ZM0 16C0 16.55 0.45 17 1 17H13C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15H1C0.45 15 0 15.45 0 16Z"
                    fill="#424167"
                  />
                </svg>
              </button>

              <button className="btn" onClick={getConditionVerbiage}>
                Refresh
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_6247_15093)">
                    <path
                      d="M17.6493 6.34902C16.0193 4.71902 13.7093 3.77902 11.1693 4.03902C7.49929 4.40902 4.47929 7.38902 4.06929 11.059C3.51929 15.909 7.26929 19.999 11.9993 19.999C15.1893 19.999 17.9293 18.129 19.2093 15.439C19.5293 14.769 19.0493 13.999 18.3093 13.999C17.9393 13.999 17.5893 14.199 17.4293 14.529C16.2993 16.959 13.5893 18.499 10.6293 17.839C8.40929 17.349 6.61929 15.539 6.14929 13.319C5.30929 9.43902 8.25929 5.99902 11.9993 5.99902C13.6593 5.99902 15.1393 6.68902 16.2193 7.77902L14.7093 9.28902C14.0793 9.91902 14.5193 10.999 15.4093 10.999H18.9993C19.5493 10.999 19.9993 10.549 19.9993 9.99902V6.40902C19.9993 5.51902 18.9193 5.06902 18.2893 5.69902L17.6493 6.34902Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6247_15093">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button
                className="btn"
                onClick={() => {
                  setPopupMode("ADD");
                  setSelectedRow(null);
                  setPopupOpen(true);
                }}
              >
                Add
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_6247_15083)">
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6247_15083">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="Detail_Contact_Tab">
          <div style={{ marginTop: "1.5%" }}>
            <Table2
              Tablecoloum={Tablecoloum}
              tableRow={data}
              load={loading}
              coloumWidthText={"ConditionVerbiage"}
              height={"auto"}
              editTable={false}
              showTotalBlock={false}
              exportInDifferentFormate={true}
              exportPopupOpen={exportPopupOpen}
              setexportPopupOpen={setExportPopupOpen}
              exportwidth={16.3}
              exporttitle={"Condition Verbiage"}
              conditionVerbiageMenu={true}
              setEditVerbiagePopupOpen={setPopupOpen}
              setEditVerbiageRowData={setSelectedRow}
              setEditVerbiageMode={setPopupMode}
              wordWrapEnabled={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConditionVerbiage;
